import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa74e1e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preview" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_3 = {
  key: 0,
  class: "select"
}
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = ["name"]
const _hoisted_6 = { class: "icons" }
const _hoisted_7 = { class: "cnk" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = ["data-dp-tooltip"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "categories"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = ["data-dp-tooltip", "onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 2,
  class: "internal-category"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PimProductsOverviewTableItemPreview = _resolveComponent("PimProductsOverviewTableItemPreview")!
  const _component_ItemIcons = _resolveComponent("ItemIcons")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", _hoisted_1, [
      (_ctx.product.product_info.main_image_url?.nl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("i", {
              class: "mas mas-fill-1 fs-6 cu-p",
              onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPreview = true)),
              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPreview = false))
            }, "visibility", 32)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showPreview)
        ? (_openBlock(), _createBlock(_component_PimProductsOverviewTableItemPreview, {
            key: 1,
            product: _ctx.product
          }, null, 8, ["product"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.AbilityContext.isAuthorizedForFeature('PIM_PRODUCT_CATEGORY'))
      ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isSelectedForCategorization) = $event)),
              type: "checkbox",
              name: 'is_selected_for_categorization_' + _ctx.product.product_info.cnk_code,
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.selectMultipleForCategorization($event)), ["shift"]))
            }, null, 8, _hoisted_5), [
              [_vModelCheckbox, _ctx.isSelectedForCategorization]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", _hoisted_6, [
      _createVNode(_component_ItemIcons, { product: _ctx.product }, null, 8, ["product"])
    ]),
    _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.product.product_info.cnk_code), 1),
    _createElementVNode("td", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_ctx.AbilityContext.isAuthorizedForFeature('PIM_PRODUCT_INFO'))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-link text-start text-decoration-none text-black lh-1 p-0",
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openOffCanvasProductDetail && _ctx.openOffCanvasProductDetail(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.product.product_info.name), 1))
          : _createCommentVNode("", true),
        (_ctx.AbilityContext.isAuthorizedForFeature('PIM_PRODUCT_CATEGORY') && _ctx.canDelete)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn fs-5 lh-1 text-danger ms-2 p-0",
              "data-dp-tooltip": _ctx.$t('removeProductFromCategorization'),
              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteProductFromCategorization && _ctx.deleteProductFromCategorization(...args)), ["prevent"]))
            }, _hoisted_12, 8, _hoisted_10))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isCategoryExpected)
      ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
          (_ctx.product.categories && _ctx.product.categories.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.categories, (category, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "row"
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("button", {
                        "data-dp-tooltip": category.path_by_name.nl,
                        onClick: _withModifiers(($event: any) => (_ctx.emitSelectedDpCat(category.code)), ["prevent"]),
                        class: "btn btn-link text-start text-decoration-none text-black lh-1 p-0"
                      }, " \"" + _toDisplayString(category.name.nl) + "\" ", 9, _hoisted_16)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, " - "))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isCategoryExpected)
      ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
          (_ctx.product.internal_categories && _ctx.product.internal_categories.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.internal_categories, (category, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "row"
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("button", {
                        onClick: _withModifiers(($event: any) => (_ctx.emitSelectedIntCat(category.code)), ["prevent"]),
                        class: "btn btn-link text-start text-decoration-none text-black lh-1 p-0"
                      }, " \"" + _toDisplayString(category.description) + "\" ", 9, _hoisted_21)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, " - "))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}